// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2UIV_","title":"Header_title__1Lht9","left":"Header_left__1f3Pd","clinicName":"Header_clinicName__1XWGZ"};